var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0956 5.32486C11.0956 5.37019 10.7403 9.86403 10.5373 11.7553C10.4102 12.9159 9.66202 13.6199 8.53969 13.6399C7.67736 13.6592 6.83319 13.6659 6.00263 13.6659C5.12085 13.6659 4.25852 13.6592 3.42148 13.6399C2.33676 13.6139 1.58789 12.8959 1.46729 11.7553C1.25852 9.85736 0.909696 5.37019 0.903213 5.32486C0.896729 5.18819 0.940818 5.0582 1.03029 4.95287C1.11847 4.85554 1.24555 4.79688 1.37912 4.79688H10.6261C10.7591 4.79688 10.8797 4.85554 10.975 4.95287C11.0638 5.0582 11.1085 5.18819 11.0956 5.32486Z",
    fill: "#FF6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.98425C12 2.71026 11.7841 2.4956 11.5247 2.4956H9.58094C9.18543 2.4956 8.8418 2.21428 8.75362 1.81762L8.64469 1.33164C8.49233 0.744327 7.9665 0.333008 7.37649 0.333008H4.62416C4.02766 0.333008 3.50702 0.744327 3.34882 1.36364L3.24703 1.81829C3.1582 2.21428 2.81457 2.4956 2.41971 2.4956H0.475902C0.215907 2.4956 0 2.71026 0 2.98425V3.23757C0 3.5049 0.215907 3.72622 0.475902 3.72622H11.5247C11.7841 3.72622 12 3.5049 12 3.23757V2.98425Z",
    fill: "#FF6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.80ecb8162fdac451aaf7f7f1cb741481.svg";
export { ForwardRef as ReactComponent };